import { CentroCustoTableMockResponse } from "../mocks/CentroCusto.js";

export default {
  data() {
    return {
      centrosCustosResponse: {
        centrosCustos: [],
        total: 0,
        page: 1
      },
      loading: false
    };
  },
  
  methods: {
    async pesquisarCentrosCustos() {
      this.loading = true;
      
      try {
        const response = await this.axios.get(this.$urls.LISTAR_CENTROS_CUSTOS, {
          params: this.filters
        });

        // A API retorna: { centrosCustos: [], page: 1, total: 2 }
        this.centrosCustosResponse = response.data;
        this.loading = false;
        
      } catch (error) {
        this.tratarErroBusca(error);
      }
    },
    
    async simularBuscaAPI() {
      return new Promise((resolve) => {
        setTimeout(() => {
          this.centrosCustosResponse = CentroCustoTableMockResponse(this.filters);
          this.loading = false;
          resolve();
        }, 1000);
      });
    },
    
    tratarErroBusca(error) {
      this.$message.error('Erro ao buscar centros de custos');
      console.error(error);
      this.loading = false;
    }
  }
};

